<apm-select
  class="segment-multiselect"
  [(ngModel)]="selectedSegment"
  [bindValue]="bindValue"
  [searchable]="true"
  [clearable]="true"
  [multiple]="multiple"
  [items]="segments$ | async"
  [colorFn]="segmentColor"
  (selectChange)="onSegmentSelectionChanged()"
  bindLabel="description"
>
</apm-select>
